export type PstyleButtonIcon = string;

export const PSTYLE_GIFT_ICON = '/icons/pstyle/Gifts.svg';

/** Ícones dos botões do diálogo de perfil (como no xat). */
export const PSTYLE_PROFILE_ACTIONS: ReadonlyArray<{
  label: string;
  icon: PstyleButtonIcon;
}> = [
  { label: 'Chat Privado', icon: '/icons/pstyle/PrivateChat.svg' },
  { label: 'Mensagem Privada', icon: '/icons/pstyle/PrivateMessage.svg' },
  { label: 'Adicionar aos Amigos', icon: '/icons/pstyle/AddAsFriend.svg' },
  { label: 'Ignorar', icon: '/icons/pstyle/Ignore.svg' },
  { label: 'Casar/BFF', icon: '/icons/pstyle/Marry.svg' },
  { label: 'Transferir', icon: '/icons/pstyle/Transfer.svg' },
  { label: 'Powers', icon: '/icons/pstyle/Powers.svg' },
  { label: 'Presentes', icon: '/icons/pstyle/Gifts.svg' },
];
